import {
	createTownsquareCypherQuery,
	createJiraIssueCypherQuery,
	createPullRequestCypherQuery,
} from '@atlassian/home-assigned/assigned-list/cypher-query-builders';
import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { RouteResource } from '@townsquare/router/resources/types';
import type { HomeResourceContext } from '@townsquare/router/types';
import { expVal } from '@townsquare/stat-sig';

import AssignedQuery, {
	AssignedQuery as AssignedQueryType,
} from '../components/__generated__/AssignedQuery.graphql';

const QUERY_CONTEXT_PREFIX_SITE = 'ari:cloud:platform::site/';
const DEFAULT_LIMIT = 25;

export const assignedResource: RouteResource<
	PreloadedQuery<AssignedQueryType, Record<string, unknown>>
> = createRelayResource<AssignedQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as HomeResourceContext;
		const accountId = context.user.accountId;
		const cloudId = context?.collabContext?.rovoWorkspace;

		const isEnabled = !!cloudId && expVal('townsquare_assigned_list', 'isEnabled', false);

		const queryContext = `${QUERY_CONTEXT_PREFIX_SITE}${context?.collabContext?.rovoWorkspace}`;

		return {
			environment: getAggRelayEnvironment(),
			query: AssignedQuery,
			variables: {
				townsquareQuery: createTownsquareCypherQuery(accountId),
				jiraIssueQuery: createJiraIssueCypherQuery(accountId),
				pullRequestQuery: createPullRequestCypherQuery(accountId),
				queryContext,
				first: DEFAULT_LIMIT,
				isEnabled: isEnabled,
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
